import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { RefreshCw, Archive } from "lucide-react";

const cls = "flex items-center gap-1.5 text-sm font-medium text-slate-700 hover:text-[#111111] px-3 py-1.5 rounded-lg hover:bg-[#F7F7F8] transition-colors";

export function ArchivioAzioni({ im, id, onDone }) {
  const [rinnovo, setRinnovo] = useState(false);
  const [data, setData] = useState("");
  const rinnova = async () => {
    try { await api.post(`/immobili/${id}/rinnova-incarico`, { scadenza: data }); toast.success("Incarico rinnovato: torna negli Incarichi attivi"); setRinnovo(false); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const ritira = async (m) => {
    if (!window.confirm(`Segnare l'immobile come ${m}? Va negli Archiviati.`)) return;
    try { await api.post(`/immobili/${id}/ritira`, { motivo: m }); toast.success("Immobile archiviato"); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (im.archiviato && im.archivio_motivo === "scaduto") {
    return rinnovo ? (
      <span className="flex items-center gap-2" data-testid="rinnovo-box">
        <input data-testid="rinnovo-data" type="date" value={data} onChange={(e) => setData(e.target.value)} className="px-2 py-1 rounded-lg border border-[var(--border)] text-sm" />
        <button data-testid="rinnovo-conferma" onClick={rinnova} disabled={!data} className="px-3 py-1.5 rounded-lg bg-[#FC82ED] text-black text-sm font-semibold disabled:opacity-40">Conferma</button>
      </span>
    ) : <button data-testid="rinnova-incarico-btn" onClick={() => setRinnovo(true)} className={cls}><RefreshCw size={15} /> Rinnova incarico</button>;
  }
  if (im.archiviato) return null;
  return (
    <>
      <button data-testid="ritira-btn" onClick={() => ritira("invenduto")} className={cls}><Archive size={15} /> Invenduto</button>
      <button data-testid="ritira-ritirato-btn" onClick={() => ritira("ritirato")} className={cls}><Archive size={15} /> Ritirato</button>
    </>
  );
}
